import appStore from '@/store';

export const dispatchInitializeApp = () => {
  appStore.dispatch('initializeApp');
};

export const dispatchPostMessageReceived = () => {
  appStore.dispatch('postMessageReceived');
};
